import React from 'react'
import { EventGQL } from '../../../../Api/events/events.types'
import { isWithinDayRange } from '../../../../Utils/dateTime/dateTimeHelpers'
import { logEvent } from '../../../../Utils/analytics/firAnalytics'
import {
  createDayTicketUrl,
  getPreviewUrl,
} from '../../../../Utils/EventHelpers/eventHelpers'
import { BoxscoreActionPrimary, BoxscoreActionSecondary } from '../styles'
import { ANALYTICS_TAGS } from '../../../../Constants/analytics'

type ActionProps = {
  event: EventGQL
  buttonText: string
}

export const BoxScoreAction: React.FC<React.PropsWithChildren<ActionProps>> = ({
  event,
  buttonText,
}) => {
  const gameUrl = `/games/${event.year}/${event.slugname}`

  const handleAction = () => {
    const params = {
      button: 'action_button',
      button_text: buttonText,
      section: 'game_ticker',
      event_id: event?.eventId,
      event_slug: event?.slugname,
    }
    if (buttonText === 'Tickets') {
      logEvent(ANALYTICS_TAGS.ticket_click, params)
      return
    }
    logEvent(ANALYTICS_TAGS.boxscore_click, params)
  }
  const shouldShowPreview = () => {
    if (event?.league !== 'PLL') return false
    if (!event?.awayTeam || !event?.homeTeam) return false
    if (buttonText !== 'Preview') return false
    if (!isWithinDayRange(event.startTime, 7)) return false
    return true
  }

  return (
    <>
      {event.urlTicket && event.eventStatus === 0 && buttonText === 'Tickets' && (
        <BoxscoreActionPrimary
          href={createDayTicketUrl(event, event.urlTicket)}
          onClick={() => handleAction()}
        >
          {buttonText}
        </BoxscoreActionPrimary>
      )}

      {event.eventStatus === 1 && buttonText === 'Watch' && (
        <BoxscoreActionPrimary
          href={event.urlStreaming}
          isLive={true}
          onClick={() => handleAction()}
        >
          {buttonText}
        </BoxscoreActionPrimary>
      )}

      {event.eventStatus === 0 && shouldShowPreview() && (
        <BoxscoreActionSecondary
          href={getPreviewUrl(event?.slugname)}
          aria-label={`Preview ${event.slugname}`}
          onClick={() => handleAction()}
        >
          {buttonText}
        </BoxscoreActionSecondary>
      )}

      {event.eventStatus >= 1 && buttonText === 'View Stats' && (
        <BoxscoreActionSecondary href={gameUrl} onClick={() => handleAction()}>
          {buttonText}
        </BoxscoreActionSecondary>
      )}
    </>
  )
}
